/**
 * OPA / SCT as its own page, under the Costing module.
 *
 * It shipped first as a fourth tab on the pricing calculator, and Max moved it out on 2026-08-29:
 * Costing is a menu of its own, and OPA is the first thing under it. The tab came off the calculator
 * in the same change — the same screen reachable two ways is the sort of thing that leaves half the
 * team using a stale bookmark.
 *
 * The component itself (30_OpaSct.jsx) is unchanged and knows nothing about where it is mounted; this
 * file is the page shell — header, sidebar, title — and nothing else.
 */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import OpaSct from './30_OpaSct';
import ModuleHelp from './ModuleHelp';
import { BACKEND_URL } from './backendConfig';
import './PricingCalculator.css';
import './SPHub.css';

/* THE GUIDE (Max 01/11: every module has one, ending on the manual where there is one). The steps point at the
   Documents tab, so onBeforeTour clicks the first tab if the screen was left on another. */
const TOUR = [
  { selector: '.opa-tabs', title: 'tourOpaSct.tabsT', body: 'tourOpaSct.tabsB' },
  { selector: '.opa-bar .sp-btn.primary', title: 'tourOpaSct.newT', body: 'tourOpaSct.newB' },
  { selector: '.opa-bar .opa-file', title: 'tourOpaSct.importT', body: 'tourOpaSct.importB' },
  { selector: '.opa-bar .opa-search', title: 'tourOpaSct.searchT', body: 'tourOpaSct.searchB' },
  { selector: '.opa-scroll table.opa-list', title: 'tourOpaSct.listT', body: 'tourOpaSct.listB' },
];

export default function OpaSctPage() {
  const { t } = useTranslation();
  /* The list loads inside OpaSct, which does not report back; the controls are drawn from the first render, so a
     short wait before the guide may open by itself is enough. */
  const [ready, setReady] = useState(false);
  useEffect(() => { const id = window.setTimeout(() => setReady(true), 900); return () => window.clearTimeout(id); }, []);
  return (
    <div className="sp-page">
      <Header />
      <div className="sp-main">
        <div className="mh-titlerow">
          <div className="sp-title">
            <h2>{t('nav.opaSct')}</h2>
            <p>{t('pricing.modeOpaSub')}</p>
          </div>
          <ModuleHelp steps={TOUR} tourKey="opaSct" ready={ready}
            onBeforeTour={() => document.querySelector('.opa-tabs .opa-tab')?.click()} />
        </div>
        <OpaSct apiBase={`${BACKEND_URL}/api`} />
      </div>
    </div>
  );
}
